import { AudioContext } from 'standardized-audio-context'
import { isRemoteAsset } from './is-remote-asset'

const metadataCache = {}

export const getAudioData = async src => {
  if (metadataCache[src]) {
    return metadataCache[src]
  }

  const audioContext = new AudioContext()

  const response = await fetch(src)
  const arrayBuffer = await response.arrayBuffer()

  const wave = await audioContext.decodeAudioData(arrayBuffer)

  const channelWaveforms = new Array(wave.numberOfChannels)
    .fill(true)
    .map((_, channel) => {
      return wave.getChannelData(channel)
    })

  const metadata = {
    channelWaveforms,
    sampleRate: audioContext.sampleRate,
    durationInSeconds: wave.duration,
    numberOfChannels: wave.numberOfChannels,
    resultId: String(Math.random()),
    isRemote: isRemoteAsset(src)
  }

  metadataCache[src] = metadata

  return metadata
}
